<div class="modal-body">
  <div class="row">
    <div class="col-12 text-center">
      <h6 class="h5">{{ 'guest_management.orders.send_email.title' | translate }}</h6>
    </div>
    <div class="col-12">
      <form [formGroup]="form" (submit)="submit()">
        <div class="row g-3">
          <div class="col-12 ">
            <div class="card">
              <div class="card-body">
                <div *ngIf="selectedEmailTypes && selectedEmailTypes.length > 0" class="row">
                  <div class="col-12 py-1">
                    <app-multi-select-with-service
                      [formControl]="emailTemplateIdControl"
                      [searchOnField]="'title'"
                      [sort]="'type'"
                      [selectionMode]="'single_model'"
                      name="email_template"
                      [service]="emailService"
                      [preselectByAttribute]="'is_primary'"
                      [filters]="{type: selectedEmailTypes}"
                      label="{{ 'guest_management.orders.send_email.form.email_template' | translate }}"
                    ></app-multi-select-with-service>
                  </div>

                  <div class="col-12 py-1">
                    <label class="form-label">
                      {{ 'guest_management.orders.send_email.form.email_type' | translate }}
                    </label>
                    <div class="input-group">
                      <input class="form-control" disabled value="{{ orderEmail ? ('enums.email_type_enum.' + orderEmail.type | translate) : '' }}" readonly>
                    </div>
                  </div>

                  <div class="col-12 py-1">
                    <label class="form-label">
                      {{ (guest ? 'guest_management.orders.send_email.form.guest_email' : 'shared.components.email_builder.recipient') | translate }}
                    </label>
                    <div class="input-group">
                      <input class="form-control" disabled value="{{ emailOverride ? emailOverride : (order?.versioned_guest?.email ?? '') }}" readonly>
                    </div>
                  </div>

                  <div class="col-12 py-1" >
                    <div formArrayName="cc_recipients">
                      <p class="small text-muted mb-1">{{ 'guest_management.orders.send_email.form.cc_recipient' | translate }}</p>
                      <ng-container
                        *ngFor="let ccRecipient of $any(form.controls.cc_recipients).controls; let index = index"
                      >
                        <div class="row py-1">
                          <div class="col-12">
                            <div class="d-flex flex-row justify-content-start align-items-start">
                              <app-form-group
                                class="flex-fill pe-3"
                                type="text"
                                name="cc_recipients_{{ index }}"
                                label=""
                                [formControl]="$any(ccRecipient)"
                              ></app-form-group>
                              <button
                                (click)="removeRecipient('cc', index)"
                                type="button"
                                class="btn btn-outline-danger"
                              >
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <button (click)="addRecipient('cc')" type="button" class="btn btn-primary w-100">
                        {{ 'guest_management.orders.send_email.form.add_cc_recipient' | translate }}
                      </button>
                    </div>
                  </div>

                  <div class="col-12 py-1">
                    <div formArrayName="bcc_recipients">
                      <p class="small text-muted mb-1">{{ 'guest_management.orders.send_email.form.bcc_recipient' | translate }}</p>
                      <ng-container
                        *ngFor="let bccRecipient of $any(form.controls.bcc_recipients).controls; let index = index"
                      >
                        <div class="row py-1">
                          <div class="col-12">
                            <div class="d-flex flex-row justify-content-start align-items-start">
                              <app-form-group
                                class="flex-fill pe-3"
                                type="text"
                                name="bcc_recipients_{{ index }}"
                                label=""
                                [formControl]="$any(bccRecipient)"
                              ></app-form-group>
                              <button
                                (click)="removeRecipient('bcc',index)"
                                type="button"
                                class="btn btn-outline-danger"
                              >
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </div>

                          </div>
                        </div>
                      </ng-container>
                      <button (click)="addRecipient('bcc')" type="button" class="btn btn-primary w-100">
                        {{ 'guest_management.orders.send_email.form.add_bcc_recipient' | translate }}
                      </button>
                    </div>
                  </div>

                  <ng-container *ngIf="emailTemplateIdControl.value">
                    <div class="col-12 py-1">
                      <app-form-group
                        name="subject"
                        label="Subject"
                        [formControl]="form.controls.subject"
                      ></app-form-group>
                    </div>

                    <div class="col-12 py-1">
                      <app-markdown-editor
                        name="pre_content"
                        label="Pre Content"
                        [formControl]="form.controls.pre_content"
                      ></app-markdown-editor>
                    </div>

                    <div class="col-12 py-1">
                      <app-markdown-editor
                        name="post_content"
                        label="Post Content"
                        [formControl]="form.controls.post_content"
                      ></app-markdown-editor>
                    </div>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="allowPreview" class="col-6 pt-3">
      <button
        [class.disabled]="!orderEmail || previewLoading"
        [disabled]="!orderEmail || previewLoading"
        class="btn btn-primary mb-2"
        (click)="showPreview()"
      >{{ 'guest_management.orders.send_email.preview' | translate }}</button>
    </div>
    <div class="col-6 text-end pt-3" [class.offset-6]="!allowPreview">
      <div class="d-inline-flex flex-column">
        <button
          [class.disabled]="!orderEmail"
          [disabled]="!orderEmail"
          class="btn btn-primary mb-2"
          (click)="submit()"
        >
          {{ 'guest_management.orders.send_email.submit' | translate: {emailType: (orderEmail ? (('enums.email_type_enum.' + orderEmail.type) | translate) : '...')} }}
          <span *ngIf="submitButtonText"><br>& {{ submitButtonText }}</span>
        </button>
        <button
          [class.disabled]="!orderEmail"
          [disabled]="!orderEmail"
          class="btn btn-secondary"
          (click)="closeEvent.emit()"
        >{{ 'guest_management.orders.send_email.cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<ng-template #emailPreviewModal>
  <div class="modal-body">
    <div class="ratio" style="--bs-aspect-ratio: 141%;">
      <iframe
        [srcdoc]="previewHtml"
      ></iframe>
    </div>
  </div>
</ng-template>
